import styled from 'styled-components';
import { mediaMax, mediaMin } from '../Media Template/Media Template';

export const Card = styled.li.attrs({
  className: 'Card',
  direction: props => props.direction,
  border: props => props.border,
  padding: props => props.padding || '0.75rem 0',
  background: props => props.background
})`
  width: 100%;
  max-width: 726px;
  display: flex;
  flex-direction: ${props => props.direction};
  padding: ${props => props.padding};
  border-top: 1px solid #f1f1f1;
  border: ${props => props.border};
  background: ${props => props.background};
  cursor: pointer;
  :hover .ImageDiv > div {
    box-shadow: 0 10px 12px 0 rgba(54, 54, 54, 0.5),
      0 -1px 10px 0 rgba(86, 86, 86, 0.5);
  }
  ${mediaMax.phone`
    flex-direction: column;
  `};
  ${mediaMin.phone`
    img {
      max-width: 225px;
    }
  `};
`;
